import React, { useState } from "react";
import { cn } from "@/libs/utils";
import { getInitials } from "@/libs/utils";

interface AvatarProps {
  src?: string;
  alt: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function Avatar({
  src,
  alt,
  size = "md",
  className,
}: AvatarProps) {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const sizes = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  };

  // Reset error state when src changes
  React.useEffect(() => {
    if (src) {
      setImageError(false);
      setImageLoaded(false);
    }
  }, [src]);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };


  return (
    <div className={cn("relative inline-block flex-shrink-0", className)}>
      {src && !imageError ? (
        <>
          <img
            src={src}
            alt={alt}
            onLoad={handleImageLoad}
            onError={handleImageError}
            className={cn(
              "rounded-full object-cover",
              sizes[size],
              !imageLoaded && "opacity-0"
            )}
          />
          {/* Show fallback while image is loading */}
          {!imageLoaded && (
            <div
              className={cn(
                "absolute inset-0 rounded-full bg-gradient-to-br from-primary to-primary/60",
                "flex items-center justify-center font-semibold text-primary-foreground",
                sizes[size]
              )}
            >
              {getInitials(alt)}
            </div>
          )}
        </>
      ) : (
        <div
          className={cn(
            "rounded-full bg-gradient-to-br from-primary to-primary/60",
            "flex items-center justify-center font-semibold text-primary-foreground",
            sizes[size]
          )}
        >
          {getInitials(alt)}
        </div>
      )}
    </div>
  );
}
